import React, { useState } from 'react';
import { Box, Button, Popover, TextField, Typography } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import dayjs from 'dayjs';
import { dropdownSx } from '../../Dashboard/Components/dashboardCardStyles';

interface DateRangePopoverProps {
  from: string; // YYYY-MM-DD
  to: string; // YYYY-MM-DD
  onChange: (range: { from: string; to: string }) => void;
}

export const DateRangePopover: React.FC<DateRangePopoverProps> = ({ from, to, onChange }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [draftFrom, setDraftFrom] = useState(from);
  const [draftTo, setDraftTo] = useState(to);

  const open = Boolean(anchorEl);
  const isInvalid = !draftFrom || !draftTo || draftFrom > draftTo;

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setDraftFrom(from);
    setDraftTo(to);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleApply = () => {
    if (isInvalid) return;
    onChange({ from: draftFrom, to: draftTo });
    setAnchorEl(null);
  };

  return (
    <>
      <Box sx={dropdownSx} onClick={handleOpen}>
        <CalendarTodayIcon sx={{ fontSize: 15, mr: 0.75 }} />
        {dayjs(from).format('MMM D, YYYY')} - {dayjs(to).format('MMM D, YYYY')}
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: { sx: { bgcolor: '#1f1f1f', border: '1px solid #2c2c2c', borderRadius: 2, mt: 1 } },
        }}
      >
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5, minWidth: 260 }}>
          <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>
            Select date range
          </Typography>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <TextField
              label="From"
              type="date"
              size="small"
              value={draftFrom}
              onChange={(e) => setDraftFrom(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ '.MuiInputBase-input': { color: '#e2e8f0' }, '.MuiInputLabel-root': { color: '#8A8D91' } }}
            />
            <TextField
              label="To"
              type="date"
              size="small"
              value={draftTo}
              onChange={(e) => setDraftTo(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ '.MuiInputBase-input': { color: '#e2e8f0' }, '.MuiInputLabel-root': { color: '#8A8D91' } }}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button size="small" onClick={handleClose} sx={{ color: '#94a3b8' }}>
              Cancel
            </Button>
            <Button size="small" variant="contained" disabled={isInvalid} onClick={handleApply}>
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};
